import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { DataProvider } from './contexts/DataContext';
import { ModelProvider } from './contexts/ModelContext';
import { TransferProvider } from './contexts/TransferContext';

import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import ProjectDashboard from './pages/ProjectDashboard';
import Dataset from './pages/Dataset';
import Editor from './pages/Editor';
import AIModels from './pages/AIModels';
import CalibrationTransfer from './pages/CalibrationTransfer';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Help from './pages/Help';
import ProjectSettings from './pages/ProjectSettings';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ProjectProvider>
          <DataProvider>
            <ModelProvider>
            <TransferProvider>
              <Router>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/login" element={<Login />} />

                  {/* Protected Routes */}
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Home />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/about"
                    element={
                      <PrivateRoute>
                        <About />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/projects"
                    element={
                      <PrivateRoute>
                        <Projects />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/help"
                    element={
                      <PrivateRoute>
                        <Help />
                      </PrivateRoute>
                    }
                  />

                  {/* Project Routes */}
                  <Route
                    path="/project/:projectId/dashboard"
                    element={
                      <PrivateRoute>
                        <ProjectDashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/dataset"
                    element={
                      <PrivateRoute>
                        <Dataset />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/editor"
                    element={
                      <PrivateRoute>
                        <Editor />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/ai"
                    element={
                      <PrivateRoute>
                        <AIModels />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/transfer"
                    element={
                      <PrivateRoute>
                        <CalibrationTransfer />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/reports"
                    element={
                      <PrivateRoute>
                        <Reports />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/project/:projectId/settings"
                    element={
                      <PrivateRoute>
                        <ProjectSettings />
                      </PrivateRoute>
                    }
                  />

                  {/* Fallback */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Router>

              <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </TransferProvider>
            </ModelProvider>
          </DataProvider>
        </ProjectProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
